import ScrollFunc from "./common/classes/scrollfunc.es6";
import MvParallax from "./top/mainvisual/mvParallax.es6";
import MvApng from "./top/mainvisual/mvApng.es6";
import ScrollParallax from "./common/classes/scrollParallax.es6";
import CableDraw from "./common/classes/cableDraw.es6";
import Banner from "./top/banner.es6";
import News from "./top/news.es6";
import NewsTicker from "./top/newsTicker.es6";
import Pv from "./top/pv.es6";
import Config from "./common/config/config";
import Intro from "./top/intro.es6";
import Storage from "./common/utils/storage.es6";

const INTRO_KEY = "intro";

export default class Top {
    constructor() {
        // scrollFunc(Lenis)生成より前にブラウザ標準の復元を無効化しておく
        if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual";
        }

        this.storage = new Storage();
        this.shouldSkipIntro = this.shouldSkipSessionIntro();

        this.scrollFunc = new ScrollFunc();
        this.mvParallax = new MvParallax();
        this.mvApng = new MvApng();
        this.scrollParallax = new ScrollParallax();
        this.cableDraw = new CableDraw({ duration: 2.8 });
        this.banner = new Banner();
        this.news = new News();
        this.newsTicker = new NewsTicker();
        this.pv = new Pv();
        if (!this.shouldSkipIntro) this.intro = new Intro();

        this.resetScrollPosition();
        this.setIntroEnd();

        this.init();
    }

    init() {}

    // イントロ中はスクロール禁止。load後、INTRO_END_MS経過でbodyに-introendを付与して解除
    setIntroEnd() {
        // イントロスキップ済みの場合は-introendを付与してスクロール禁止を解除
        if (this.shouldSkipIntro) {
            document.body.classList.add("-introend");
            return;
        }

        this.scrollFunc.lockScroll();

        window.addEventListener("load", () => {
            setTimeout(() => {
                this.storage.set(INTRO_KEY, false);
                document.body.classList.add("-introend");
                this.scrollFunc.unlockScroll();
            }, Config.INTRO_END_MS);
        });
    }

    // リロード時にページ先頭(0)へ戻す
    resetScrollPosition() {
        // 即時にLenis経由で先頭へ
        this.scrollFunc.scrollToTop();
        window.scrollTo(0, 0);

        // load完了後にブラウザ/画像読み込みで位置がずれるケースに対応
        window.addEventListener("load", () => {
            this.scrollFunc.scrollToTop();
            window.scrollTo(0, 0);
        });

        // SP等でloadが発火しないbfcache(戻る/進む)復元時も先頭へ戻す
        window.addEventListener("pageshow", () => {
            this.scrollFunc.scrollToTop();
            window.scrollTo(0, 0);
        });
    }

    // 同一タブ内でイントロ再生済みならスキップする
    // 初回(フル演出)なら-firstintro、再生済みなら-skipIntroをbodyに付与
    shouldSkipSessionIntro() {
        if (this.storage.get(INTRO_KEY) !== false) {
            document.body.classList.add("-firstIntro");
            return false;
        }

        document.body.classList.add("-skipIntro");
        return true;
    }
}

const top = new Top();
